
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

import DialogOrderProcess from "./components/OrderProcessDialog.vue"

import {
  getOrderDispose,
  orderAssign,
  orderTransfer,
  orderFinish,
  orderCheck,
  getOrderDetail,
} from '@/api/orderService';
import {
  checkPermissionCompanyFromOrderType,
  checkPermissionRole,
  getModelPermission,
  checkServerAppointmentTimeIsMust,
  checkPermissionUseAndCompany,
} from '@/utils/permission';

import { ModuleType, ViewType, Type } from '@/types/permissionType';
import { bottomBtnOrderState } from '@/utils/orderStatsUtils';
import OrderInfo from '@/components/OrderInfo/OrderInfo.vue'
import OrderServiceInfo from '@/components/OrderInfo/OrderServiceInfo.vue'
import OrderTopTitle from '@/components/OrderInfo/OrderTopTitle.vue'

@Component({
  name: 'orderServicerTodeal',
  components: {
    DialogOrderProcess,
    OrderTopTitle,
    OrderInfo,
    OrderServiceInfo
  },
  filters: {

  }
})
export default class extends Vue {
  private formInformation: any = {
    appointment: '',
    expedited: false,
    tag: '',
    tags: '',
    brand: '',
    device: '',
    parts: '',
    image: [],
    video: [],
    word: [],

    evaluate: '',

    costType: '',
    costValue: '',
    remark: '',
    order_task_list: [],

    dynamicOrderSend: [],
    dynamicCost: [],
    dynamicFault: [],
    dynamicPhenomenon: [],
    dynamicRemark: [],
  };
  private companyId = '';
  private orderServiceId = '';
  private orderDetail: any = {
    order: {},
    order_service: {}
  };
  private isDetail=false;
  private isTransferOut=false;

  private productModelPermission: any = { v: 0 };
  private deviceModelPermission: any = { v: 0 };
  private partsModelPermission: any = { v: 0 };
  private remarkModelPermission: any = { v: 0 };
  private faultModelPermission: any = { v: 0 };
  private phenomenonPermission: any = { v: 0 };
  private deviceSnPermission: any = { v: 0 };
  private costModelPermission: any = { v: 0 };
  private picModelPermission: any = { v: 0 };
  private videoModelPermission: any = { v: 0 };
  private tagModelPermission: any = { v: 0 };
  private diyOneModelPermission: any = { v: 0 };
  private diyTwoModelPermission: any = { v: 0 };
  private wordModelPermission: any = { v: 0 };

  private appointmentTimeMust = false;
  private orderId=''
  private orderState = 0;
  private topButtonList:any=[]

  private tabList:any=[];

  created() {
    this.orderServiceId = this.$route.query.order_service_id as any;
    this.companyId = this.$route.query.company_id as any;
    this.getOrderDispose(this.orderServiceId);
  }

  private confirmButton = false

  private getOrderDispose(orderServiceId:string) {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_service_id: orderServiceId
    };
    getOrderDispose(params)
      .then((res: any) => {
        if (res.data) {
          this.orderDetail = res.data;
          this.orderId = this.orderDetail.order.id;
          if (this.orderDetail.order.parts_list) {
            for (var bean of this.orderDetail.order.parts_list) {
              bean.str =
                this.isNull(bean.parts_name) +
                '/' +
                this.isNull(bean.parts_model_name) +
                '/' +
                this.isNull(bean.parts_amount) +
                '/' +
                this.isNull(bean.parts_unit_price) +
                '/' +
                this.isNull(bean.parts_price) +
                '/' +
                this.isNull(bean.parts_attribute_name);
            }
          }
          if (this.orderDetail.order_service.video_list) {
            for (var bean2 of this.orderDetail.order_service.video_list) {
              bean2.img_url = bean2.full_path;
            }
          }
          this.formInformation.dynamicCost = this.orderDetail.order.order_price;
          this.formInformation.dynamicFault = this.orderDetail.order.fault_list;
          this.formInformation.dynamicPhenomenon = this.orderDetail.order.fault_phenomenon_list;
          if (this.orderDetail.order.order_task) {
            this.orderDetail.order.order_task.forEach((element:any) => {
              if (!this.orderDetail.order.order_remark) {
                this.orderDetail.order.order_remark = []
              }
              this.orderDetail.order.order_remark.push({
                classify_name: '',
                remark: "【维修小结】" + element.fix_summary,
                addtime: element.finish_time,
                user_name: element.user_name })
            });
          }
          this.formInformation.dynamicRemark = this.orderDetail.order.order_remark;

          // this.evaluate = this.orderDetail.order_service.order_price;

          // 寄修信息
          if (this.orderDetail.order_task && this.orderDetail.order_task.order_send) {
            let outsend = {
              type: '1',
              title: '寄出信息',
              name: this.orderDetail.order_task.order_send.send_name,
              mobile: this.orderDetail.order_task.order_send.send_mobile ? this.orderDetail.order_task.order_send.send_mobile : this.orderDetail.order_task.order_send.send_phone_num,
              address: this.orderDetail.order_task.order_send.send_province_name + this.orderDetail.order_task.order_send.send_city_name + this.orderDetail.order_task.order_send.send_district_name + this.orderDetail.order_task.order_send.send_address,
              deliveryName: this.orderDetail.order_task.order_send.send_express_name,
              deliveryNumber: this.orderDetail.order_task.order_send.send_express_number
            }
            this.formInformation.dynamicOrderSend.push(outsend);

            let insend = {
              title: '寄回信息',
              name: this.orderDetail.order_task.order_send.reply_name,
              mobile: this.orderDetail.order_task.order_send.reply_mobile ? this.orderDetail.order_task.order_send.reply_mobile : this.orderDetail.order_task.order_send.reply_phone_num,
              address: this.orderDetail.order_task.order_send.reply_province_name + this.orderDetail.order_task.order_send.reply_city_name + this.orderDetail.order_task.order_send.reply_district_name + this.orderDetail.order_task.order_send.reply_address,
              deliveryName: this.orderDetail.order_task.order_send.reply_express_name,
              deliveryNumber: this.orderDetail.order_task.order_send.reply_express_number
            }
            this.formInformation.dynamicOrderSend.push(insend);
          }
          this.formInformation.tags = this.orderDetail.order.tags;
          this.formInformation.order_check_event_list = this.orderDetail.order_check_event_list;
          this.formInformation.brand = this.orderDetail.order_service.brand_list;
          this.formInformation.device = this.orderDetail.order_service.device_list;
          this.formInformation.parts = this.orderDetail.order.parts_list;
          this.formInformation.image = this.orderDetail.order.order_image;
          this.formInformation.video = this.orderDetail.order_service.video_list;
          if (this.orderDetail.order_service.document_list) {
            this.formInformation.word = this.orderDetail.order_service.document_list;
          } else {
            this.formInformation.word = [];
          }
          if (this.formInformation.word) {
            this.formInformation.word.map(function(item:any) {
              item.name = item.original_name;
            });
          }
          this.formInformation.order_task_list = this.orderDetail.order_task_list;
          if (this.orderDetail.order_service.servicer_appointment_timestamp && parseInt(this.orderDetail.order_service.servicer_appointment_timestamp) !== 0) {
            this.formInformation.appointment = this.orderDetail.order_service.servicer_appointment_timestamp + '000';
          }
          this.$set(this.formInformation, 'expedited', parseInt(this.orderDetail.order_service.expedited) === 1);
          this.$set(this.formInformation, 'isFree', parseInt(this.orderDetail.order_service.is_charge) === 1);
          this.isTransferOut = parseInt(this.orderDetail.order_service.transfer_out) === 1

          if (this.orderDetail.order_service_list && this.isTransferOut) {
            this.tabList = this.orderDetail.order_service_list.filter((s:any) => {
              return s.order_service_id !== this.orderServiceId
            })
            let current = this.orderDetail.order_service_list.filter((s:any) => {
              return s.order_service_id === this.orderServiceId
            })
            this.tabList.unshift(current[0]);
            this.companyName = this.tabList[0].order_service_id
          }
          var dealType = 0;
          this.appointmentTimeMust = checkServerAppointmentTimeIsMust(this.orderDetail.order.order_type, this.companyId);
          if (this.orderDetail.order_task != null) {
            dealType = this.orderDetail.order_task.deal_type;
          }
          this.setPermission(dealType, this.orderDetail.order.order_type);
          if (!this.isDetail) {
            this.configCheck();
          }
          this.initButtonList(this.orderDetail);
        }
      })
      .catch((err: any) => {
        let msg = err.msg
      });
  }
  private getOrderDetail(orderServiceId:string) {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_service_id: orderServiceId,
      point_service_id: orderServiceId
    };
    getOrderDetail(params)
      .then((res: any) => {
        if (res.data) {
          this.orderDetail = res.data;
          this.topButtonList = [];
        }
      })
      .catch((err: any) => {
        let msg = err.msg
      });
  }
  private initButtonList(orderDetail:any) {
    this.orderState = bottomBtnOrderState(
      parseInt(orderDetail.order_service.state)
    );
    this.confirmButton = (((this.orderState > 1 && this.orderState < 6) || this.orderState === 8) && parseInt(this.orderDetail.order_service.transfer_in) !== 1 && checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.ORDER_CONFIRM_CUSTOMER, this.orderDetail.order.order_type) && checkPermissionRole(this.orderDetail.order_service.servicer_company_id, Type.ORDER_CONFIRM_CUSTOMER))
    this.topButtonList = [
      { id: 7,
        show: parseInt(orderDetail.order.order_type) !== 4 && parseInt(orderDetail.order_service.transfer_out) !== 1,
        info: '实际收费' },
      { id: 1,
        style: 'color: #f00',
        show: (this.orderState === 1 || this.orderState === 2 || this.orderState === 4 || this.orderState === 5) &&
         parseInt(orderDetail.order_service.transfer_out) !== 1 &&
        checkPermissionCompanyFromOrderType(orderDetail.order_service.servicer_company_id, Type.ORDER_HANDUP, orderDetail.order.order_type) &&
        checkPermissionRole(orderDetail.order_service.servicer_company_id, Type.ORDER_HANDUP),
        info: '挂单' },
      // { id: 2,
      //   show: this.orderState > 1 && this.orderState < 6 &&
      //         parseInt(orderDetail.order_service.transfer_in) !== 1 &&
      //         checkPermissionCompanyFromOrderType(orderDetail.order_service.servicer_company_id, Type.ORDER_CONFIRM_CUSTOMER, orderDetail.order.order_type) &&
      //         checkPermissionRole(orderDetail.order_service.servicer_company_id, Type.ORDER_CONFIRM_CUSTOMER),
      //   info: orderDetail.order.order_type === "4" ? "服务完成" : "代客确认" },
      { id: 3,
        style: 'color: #f00',
        show: (this.orderState === 1 || this.orderState === 2 || this.orderState === 4 || this.orderState === 5 || this.orderState === 3 || this.orderState === 8) &&
              checkPermissionCompanyFromOrderType(orderDetail.order_service.servicer_company_id, Type.ORDER_CLOSE, orderDetail.order.order_type) &&
              checkPermissionRole(orderDetail.order_service.servicer_company_id, Type.ORDER_CLOSE) && parseInt(orderDetail.order_service.transfer_in) !== 1,
        info: '关闭' },
      // { id: 6,
      //   show: this.orderState === 6 && orderDetail.order_service.evaluate_state !== '1',
      //   info: '评价' },
      { id: 8,
        show: checkPermissionUseAndCompany(UserModule.getCompanyId, Type.ORDER_COMPLAINT_DEAL) && parseInt(orderDetail.order_service.complaint_state) !== 0 && parseInt(orderDetail.order_service.complaint_state) !== 8,
        info: '投诉' },
      { id: 4,
        show: this.orderState === 6 && parseInt(orderDetail.order.order_type) !== 4 &&
        parseInt(orderDetail.order_service.transfer_out) !== 1 &&
        parseInt(orderDetail.order_service.is_return_visit) !== 1 && parseInt(orderDetail.order_service.transfer_in) !== 1 &&
        checkPermissionRole(orderDetail.order_service.servicer_company_id, Type.ORDER_DEAL),
        info: '回访' },
      { id: 5,
        style: "color: #f00",
        show: this.orderState >= 6 && this.orderState !== 8 && checkPermissionCompanyFromOrderType(orderDetail.order_service.servicer_company_id, Type.ORDER_CLOSE, orderDetail.order.order_type),
        info: '删除' },
    ]
  }
  private dealList:any=[];
  private isShowDeal=true;
  private setPermission(dealType: any, orderType:any) {
    this.dealList = [
      { id: 1,
        show: checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN_SELF, this.orderDetail.order.order_type) &&
                checkPermissionRole(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN_SELF),
        text: '派给自己' },

      { id: 3,
        show: checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN, this.orderDetail.order.order_type) &&
                checkPermissionRole(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN),
        text: '分派至工程师' },
      { id: 2,
        show: checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN, this.orderDetail.order.order_type) &&
                checkPermissionRole((this.orderDetail && this.orderDetail.order_service) ? this.orderDetail.order_service.servicer_company_id : 0, Type.ORDER_ASSIGN),
        text: '分派至部门' },
      { id: 4,
        show: false,
        text: '转单' },
      { id: 5,
        show: false,
        text: '分配询价' }
      ]
    let arr = this.dealList.filter((deal:any) => {
      return deal.show === true
    })
    if (arr && arr.length > 0) {
      this.isShowDeal = true;
    } else {
      this.isShowDeal = false;
    }
    this.productModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_PRODUCT,
      orderType
    );
    this.deviceModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DEVICE,
      orderType
    );
    this.partsModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_PARTS,
      orderType
    );
    this.remarkModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_REMARK,
      orderType
    );
    this.diyOneModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DIY_ONE,
      orderType
    );
    this.wordModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_WORD_FILE,
      orderType
    );
    this.diyTwoModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DIY_TWO,
      orderType
    );
    this.faultModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_FAULTTYPE,
      orderType
    );
    this.phenomenonPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_FAULTPHENOMENON,
      orderType
    );
    this.deviceSnPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_SN,
      orderType
    );
    this.costModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_COST,
      orderType
    );
    this.picModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DEAL_IMAGE,
      orderType
    );
    this.videoModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_DEAL_VIDEO,
      orderType
    );
    this.tagModelPermission = this.setPermissionWithType(
      dealType,
      ModuleType.ORDER_TAG,
      orderType
    );
  }

  private setPermissionWithType(dealType: any, moduleType: ModuleType, orderType:any) {
    return getModelPermission(
      ViewType.DEAL_ORDER,
      orderType,
      dealType,
      this.companyId,
      moduleType
    );
  }
  private checkDealPermission(p:any) {
    if (!checkPermissionRole(this.companyId, p)) {
      this.$alert('', '您没有该订单处理权限', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return false;
    } else {
      return true;
    }
  }

  private isNull(val: any) {
    if (val) {
      return val;
    } else {
      return '~';
    }
  }
  //= ================================处理操作=================================
  private unfinishOrderTaskNum: any = 0;
  private unfinishOrderTaskVisibility: any = false;
  private assign(radioWay:number, selectedUserData: any, selectedData: any, service: any, taskCoordinationVisble: any, taskCoordination: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      expedited: this.formInformation.expedited ? '1' : '0',
      company_id: this.companyId
    };
    params.order_service_id = this.orderDetail.order_service.id;
    switch (radioWay) {
      case 1:
        if (!this.checkDealPermission(Type.ORDER_ASSIGN_SELF)) {
          return;
        }
        if (this.checkMust()) {
          let workUser:any = {
            user_id: UserModule.getUserId,
            user_name: UserModule.getUserName
          };
          if (selectedData.id) {
            workUser.dept_id = selectedData.id;
            workUser.dept_name = selectedData.name;
          }
          let arr:any = [];
          arr.push(workUser);
          params.work_user = JSON.stringify(arr);
          if (taskCoordinationVisble) {
            params.is_assign_other_task_complete = taskCoordination ? '1' : '0'
          }
          orderAssign(params)
            .then((res: any) => {
              this.showSuccessMsg(res.msg);
              this.$router.go(-1);
            })
            .catch((err: any) => {
              this.showErrorMsg(err.msg);
            });
        } else {
          this.selectedOrderProcessVisible = false
        }
        break;
      case 2:
      case 3:
      case 5:
        if (radioWay === 5) {
          if (!this.checkDealPermission(Type.ORDER_ASSIGN)) {
            return;
          }
        }
        if (this.checkMust()) {
          if (radioWay === 2) {
            // 派单至部门
            if (!selectedData.name) {
              this.showErrorMsg('请选择部门');
              return;
            }
            params.work_department_id = selectedData.id;
            params.work_department_name = selectedData.name;
          }
          if (radioWay === 3 || radioWay === 5) {
            // 派单工程师
            if (!selectedData.name) {
              this.showErrorMsg('请选择部门');
              return;
            }
            if ((selectedUserData as any).length <= 0) {
              this.showErrorMsg('请选择工程师');
              return;
            }
            var userList1: any = [];
            for (const assign of selectedUserData) {
              var assingBean = {
                user_id: assign.user.user_id,
                name: assign.user.name,
                dept_id: assign.dept_id ? assign.dept_id : '',
                dept_name: assign.dept_id ? assign.dept_name : ''
              };
              userList1.push(assingBean);
            }
            params.work_user = JSON.stringify(userList1);
          }
          if (radioWay === 5) {
            params.is_assign_enquiry = '1'
          } else {
            if (taskCoordinationVisble) {
              params.is_assign_other_task_complete = taskCoordination ? '1' : '0'
            }
          }
          orderAssign(params)
            .then((res: any) => {
              this.showSuccessMsg(res.msg);
              this.$router.go(-1);
            })
            .catch((err: any) => {
              this.showErrorMsg(err.msg);
            });
        } else {
          this.selectedOrderProcessVisible = false
        }
        break;
      case 4:
        if (!this.checkDealPermission(Type.ORDER_TRANSFER)) {
          return;
        }
        // UrlName.ORDERSERVICE_ORDERTRANSFER
        if (!service) {
          this.showErrorMsg('请选择合作服务方');
          return;
        }
        params.transfer_company_id = service.servicer_company_id;
        params.transfer_company_name = service.name;

        if ((!this.formInformation || !this.formInformation.appointment) && this.appointmentTimeMust) {
          this.showErrorMsg('请选择预约时间');
          return;
        }
        orderTransfer(params)
          .then((res: any) => {
            this.showSuccessMsg(res.msg);
            this.$router.go(-1);
          })
          .catch((err: any) => {
            this.showErrorMsg(err.msg);
          });
        break;
    }
  }
  private customerConfirm() {
    if (this.checkMust()) {
      // 确认完成此订单?
      // 当前订单还有1个维修人员未处理完成!
      this.unfinishOrderTaskNum = this.orderDetail.order_service.unfinish_order_task_num;
      this.unfinishOrderTaskVisibility = this.unfinishOrderTaskNum !== 0;
      if (this.unfinishOrderTaskNum === 0) {
        this.$confirm('确认完成此订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.orderFinish();
          })
      }
    }
  }
  private orderFinish() {
    if (this.needCheckTask()) {
      this.handleCheck();
      return;
    }
    var finishParams: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_service_id: this.orderDetail.order_service.id
    };
    orderFinish(finishParams)
      .then((res: any) => {
        this.unfinishOrderTaskVisibility = false;
        this.showSuccessMsg(res.msg);
        this.$router.go(-1);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private checkMust() {
    if ((!this.formInformation || !this.formInformation.appointment) && this.appointmentTimeMust) {
      this.showErrorMsg('请选择预约时间');
      return false;
    }
    if (
      parseInt(this.tagModelPermission.m) === 1 &&
      !(this.formInformation.tags && this.formInformation.tags.length)
    ) {
      this.showErrorMsg(this.tagModelPermission.me);
      return false;
    }
    if (
      parseInt(this.productModelPermission.m) === 1 &&
      (!this.formInformation.brand || this.formInformation.brand.length < 0)
    ) {
      this.showErrorMsg(this.productModelPermission.me);
      return false;
    }
    if (
      parseInt(this.deviceModelPermission.m) === 1 &&
      !this.formInformation.device
    ) {
      this.showErrorMsg(this.deviceModelPermission.me);
      return false;
    }
    if (
      parseInt(this.partsModelPermission.m) === 1 &&
      !this.formInformation.parts
    ) {
      this.showErrorMsg(this.partsModelPermission.me);
      return false;
    }
    if (
      parseInt(this.picModelPermission.m) === 1 &&
      !(this.formInformation.image && this.formInformation.image.length > 0)
    ) {
      this.showErrorMsg(this.picModelPermission.me);
      return false;
    }
    if (
      parseInt(this.videoModelPermission.m) === 1 &&
      !(this.formInformation.video && this.formInformation.video.length > 0)
    ) {
      this.showErrorMsg(this.videoModelPermission.me);
      return false;
    }
    if (
      parseInt(this.wordModelPermission.m) === 1 &&
      !(this.formInformation.word && this.formInformation.word.length > 0)
    ) {
      this.showErrorMsg(this.wordModelPermission.me);
      return false;
    }
    if (
      parseInt(this.costModelPermission.m) === 1 &&
      !(this.formInformation.dynamicCost && this.formInformation.dynamicCost.length > 0)
    ) {
      this.showErrorMsg(this.costModelPermission.me);
      return false;
    }
    if (
      parseInt(this.phenomenonPermission.m) === 1 &&
      !(this.formInformation.dynamicPhenomenon && this.formInformation.dynamicPhenomenon.length > 0)
    ) {
      this.showErrorMsg(this.phenomenonPermission.me);
      return false;
    }
    if (parseInt(this.deviceSnPermission.m) === 1 && !this.orderDetail.order.device_sn) {
      this.showErrorMsg("请输入设备编号");
      return false;
    }
    if (
      parseInt(this.faultModelPermission.m) === 1 &&
      !(this.formInformation.dynamicFault && this.formInformation.dynamicFault.length > 0)
    ) {
      this.showErrorMsg(this.faultModelPermission.me);
      return false;
    }
    if (
      parseInt(this.remarkModelPermission.m) === 1 &&
      !(this.formInformation.dynamicRemark && this.formInformation.dynamicRemark.length > 0)
    ) {
      this.showErrorMsg(this.remarkModelPermission.me);
      return false;
    }
    if (parseInt(this.diyOneModelPermission.m) === 1 && !this.orderDetail.order.diy_one_content) {
      this.showErrorMsg(this.diyOneModelPermission.me);
      return false;
    }
    if (parseInt(this.diyTwoModelPermission.m) === 1 && !this.orderDetail.order.diy_two_content) {
      this.showErrorMsg(this.diyTwoModelPermission.me);
      return false;
    }
    return true;
  }

    private checkTransMust() {
    if ((!this.formInformation || !this.formInformation.appointment) && this.appointmentTimeMust) {
      this.showErrorMsg('请选择预约时间');
      return false;
    }
    if (
      parseInt(this.tagModelPermission.m) === 1 &&
      !(this.formInformation.tags && this.formInformation.tags.length)
    ) {
      this.showErrorMsg(this.tagModelPermission.me);
      return false;
    }
    if (
      parseInt(this.productModelPermission.m) === 1 &&
      (!this.formInformation.brand || this.formInformation.brand.length < 0)
    ) {
      this.showErrorMsg(this.productModelPermission.me);
      return false;
    }
    // if (
    //   parseInt(this.deviceModelPermission.m) === 1 &&
    //   !this.formInformation.device
    // ) {
    //   this.showErrorMsg(this.deviceModelPermission.me);
    //   return false;
    // }
    // if (
    //   parseInt(this.partsModelPermission.m) === 1 &&
    //   !this.formInformation.parts
    // ) {
    //   this.showErrorMsg(this.partsModelPermission.me);
    //   return false;
    // }
    // if (
    //   parseInt(this.picModelPermission.m) === 1 &&
    //   !(this.formInformation.image && this.formInformation.image.length > 0)
    // ) {
    //   this.showErrorMsg(this.picModelPermission.me);
    //   return false;
    // }
    if (
      parseInt(this.videoModelPermission.m) === 1 &&
      !(this.formInformation.video && this.formInformation.video.length > 0)
    ) {
      this.showErrorMsg(this.videoModelPermission.me);
      return false;
    }
    if (
      parseInt(this.wordModelPermission.m) === 1 &&
      !(this.formInformation.word && this.formInformation.word.length > 0)
    ) {
      this.showErrorMsg(this.wordModelPermission.me);
      return false;
    }
    // if (
    //   parseInt(this.costModelPermission.m) === 1 &&
    //   !(this.formInformation.dynamicCost && this.formInformation.dynamicCost.length > 0)
    // ) {
    //   this.showErrorMsg(this.costModelPermission.me);
    //   return false;
    // }
    if (
      parseInt(this.phenomenonPermission.m) === 1 &&
      !(this.formInformation.dynamicPhenomenon && this.formInformation.dynamicPhenomenon.length > 0)
    ) {
      this.showErrorMsg(this.phenomenonPermission.me);
      return false;
    }
    // if (
    //   parseInt(this.faultModelPermission.m) === 1 &&
    //   !(this.formInformation.dynamicFault && this.formInformation.dynamicFault.length > 0)
    // ) {
    //   this.showErrorMsg(this.faultModelPermission.me);
    //   return false;
    // }
    if (
      parseInt(this.remarkModelPermission.m) === 1 &&
      !(this.formInformation.dynamicRemark && this.formInformation.dynamicRemark.length > 0)
    ) {
      this.showErrorMsg(this.remarkModelPermission.me);
      return false;
    }
    if (parseInt(this.diyOneModelPermission.m) === 1 && !this.orderDetail.order.diy_one_content) {
      this.showErrorMsg(this.diyOneModelPermission.me);
      return false;
    }
    if (parseInt(this.diyTwoModelPermission.m) === 1 && !this.orderDetail.order.diy_two_content) {
      this.showErrorMsg(this.diyTwoModelPermission.me);
      return false;
    }

    if (this.orderDetail.order.parts_list && this.orderDetail.order.parts_list.length > 0) {
      this.showErrorMsg("已添加备件,可删除后转单");
      return;
    }
    if (this.orderDetail.order_service.device_list && this.orderDetail.order_service.device_list.length > 0) {
      this.showErrorMsg("已添加设备,可删除后转单");
      return;
    }
    if (this.orderDetail.order.order_price && this.orderDetail.order.order_price.length > 0) {
      this.showErrorMsg("已添加费用,可删除后转单");
      return;
    }
    if (this.orderDetail.order.fault_list && this.orderDetail.order.fault_list.length > 0) {
      this.showErrorMsg("已添加故障类型,可删除后转单");
      return;
    }

    return true;
  }

  private dealDetailHandle(row: any) {}

  private toOrderList(row:any, taskStage:number) {
    if ((taskStage === 2 && row.task_untreated_count > 0) || (taskStage === 3 && row.task_underway_count > 0)) {
      this.$router.push(
        {
          path: '/OrderServicer/underway',
          query: {
            work_user_id: row.user.user_id,
            task_stage: taskStage + ''
          }
        }
      );
    }
  }
  /**
   * 审核处理
  */
  private configCheck() {
    if (this.needCheckTask()) this.handleCheck();
  }
  private needCheckTask() {
    let priceLimit = this.orderDetail.order.order_check_price_limit;
    if (priceLimit) {
      var totalPrice = 0.0;
      if (this.formInformation.dynamicCost) {
        for (const item of this.formInformation.dynamicCost) {
          totalPrice += parseFloat(item.price_num);
        }
      }
      if (this.formInformation.parts) {
        for (const item of this.formInformation.parts) {
          totalPrice += parseFloat(item.parts_price);
        }
      }
      if (this.orderDetail.order.check_state !== '71' && totalPrice >= parseFloat(priceLimit)) {
        return true;
      }
    }
    return false;
  }
  private checkVisible = false;
  private checkModel: any = {
    remark: '',
    title: ''
  }
  private handleCheck() {
    let priceLimit = this.orderDetail.order.order_check_price_limit;
    // let tip = '金额超过' + priceLimit + '元, 请提交审核';
    let tip = '您的订单金额超过限制，请提交审核！';
    this.checkVisible = true;
    this.checkModel.title = tip;
  }
  private clickToCancleCheck() {
    this.checkVisible = false;
  }
  private clickToCheck() {
    if (!this.checkModel.remark) {
      this.showErrorMsg('请填写提审备注');
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_id: (this.orderDetail as any).order.id,
      order_service_id: (this.orderDetail as any).order_service.id,
      order_check_is_price: 1,
      remark: this.checkModel.remark
    };
    orderCheck(params).then(res => {
      this.showSuccessMsg('提审成功');
      setTimeout(() => {
        this.$router.go(-1);
      }, 0.8 * 1000);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private selectedOrderProcessVisible = false
  private OrderProcessType = '1';
  private sendOrderToHandle(type:any) {
    //如果是转单和分配询价 必填单独判断
    if (type === 'transfer') {
      if (this.checkTransMust()) {
        this.dealList = [
        { id: 1,
        show: false,
        text: '派给自己' },
        { id: 3,
          show: false,
          text: '分派至工程师' },
        { id: 2,
          show: false,
        text: '分派至部门' },
        { id: 4,
          show: checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.ORDER_TRANSFER, this.orderDetail.order.order_type) &&
                  checkPermissionRole(this.orderDetail.order_service.servicer_company_id, Type.ORDER_TRANSFER),
          text: '转单' },
          { id: 5,
          show: false,
          text: '分配询价' }
        ]
        this.selectedOrderProcessVisible = true
        return;
      }
      return;
    }
    if(type === 'enquiry') {
      if (this.checkMust()) {
        this.dealList = [
        { id: 1,
        show: false,
        text: '派给自己' },
        { id: 3,
          show: false,
          text: '分派至工程师' },
        { id: 2,
          show: false,
        text: '分派至部门' },
        { id: 4,
          show: false,
          text: '转单' },
        { id: 5,
          show: checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.OrderEnquiry, this.orderDetail.order.order_type) &&
                  checkPermissionRole(this.orderDetail.order_service.servicer_company_id, Type.OrderEnquiry),
          text: '分配询价' }
        ]
        this.selectedOrderProcessVisible = true
        return;
      }
      return;
    }
    if (this.checkMust()) {
      this.dealList = [
      { id: 1,
        show: checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN_SELF, this.orderDetail.order.order_type) &&
                checkPermissionRole(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN_SELF),
        text: '派给自己' },

      { id: 3,
        show: checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN, this.orderDetail.order.order_type) &&
                checkPermissionRole(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN),
        text: '分派至工程师' },
      { id: 2,
        show: checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.ORDER_ASSIGN, this.orderDetail.order.order_type) &&
                checkPermissionRole((this.orderDetail && this.orderDetail.order_service) ? this.orderDetail.order_service.servicer_company_id : 0, Type.ORDER_ASSIGN),
        text: '分派至部门' },
      { id: 4,
        show: false,
        text: '转单' },
      { id: 5,
        show: false,
        text: '分配询价' }
      ]
      this.selectedOrderProcessVisible = true
    }
  }
  private selectedOrderProcessClose(val: boolean) {
    this.selectedOrderProcessVisible = val
  }

  private companyName = ''
  private companyTabClick(val:any) {
    this.companyName = val;
    if (this.companyName === this.orderServiceId) {
      this.getOrderDispose(this.companyName);
      this.isDetail = false;
    } else {
      this.getOrderDetail(this.companyName)
      this.isDetail = true;
    }
  }
  private referesh() {
    if (this.companyName && this.companyName !== this.orderServiceId) {
      this.getOrderDetail(this.companyName)
    } else {
      this.getOrderDispose(this.orderServiceId)
    }
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
